import _typeof from "@babel/runtime/helpers/typeof";
export var ymPushParams = function ymPushParams() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 26001372;
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === undefined) return;
  var _window = window;
  if (_window.ym) {
    _window.ym(id, 'params', payload);
  }
};
export function withBlockPayment(value) {
  return {
    main: {
      block_payment: value
    }
  };
}